import { MsalService } from '@azure/msal-angular';
import { ProfileService } from '../profile/profile.service';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ProfileModelService, Profile, Role } from '../profile/profile-model.service';
@Injectable()
export class AzureProfileAdminGuard implements CanActivate {
  constructor(private authService: MsalService, private profileService: ProfileService, private profileModelService: ProfileModelService) {
  }

  isAdmin(profileData: Profile) {
    return profileData && profileData.role ? (profileData.role.profileAccess === Role.ADMIN) : false;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return new Promise((resolve) => {
      const userClaims = this.authService.instance.getAllAccounts()[0] as any;
      const isAuthenticated = !!userClaims;
      if (isAuthenticated) {
        if (!this.profileModelService.isAuthenticated) {
          this.profileService.updateUserName(this.getUserEmail(userClaims), userClaims.name).subscribe(
              (profileData: Profile) => {
                this.profileModelService.profile = profileData;
                resolve(this.isAdmin(profileData));
              },
              (error) => {
                this.profileService.get(this.getUserEmail(userClaims)).subscribe(
                  (profileData) => {
                    this.profileModelService.profile = profileData;
                    resolve(this.isAdmin(profileData));
                  }
                );
              }
            );
        } else {
          resolve(this.isAdmin(this.profileModelService.getProfile()));
        }
      } else {
        resolve(false);
      }
    });
  }
  private getUserEmail(user): string {
    if(user.idTokenClaims != null){
      return user.idTokenClaims.email || user.idTokenClaims.preferred_username;
    }
    return user.username;
  }

}
